export const UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER = 'UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER'
export const UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER_PENDING = 'UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER_PENDING'
export const UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER_SUCCESS = 'UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER_SUCCESS'
export const UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER_FAILURE = 'UPDATE_NRO_DOC_CONTA_PAGAR_RECEBER_FAILURE'
